const formatCAIWallet = (walletData) => {
	const parseCurrency = (n) => {
		const num = n ?? 0;
		const currencyOptions = {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: num % 1 ? 2 : 0,
			maximumFractionDigits: num % 1 ? 2 : 0
		};
		return parseFloat(num, 10).toLocaleString('en-US', currencyOptions);
	};

	const creditRange = {
		a: 'Excellent',
		b: 'Very Good',
		c: 'Good',
		d: 'Fair',
		e: 'Rebuilding'
	};

	const {
		budget,
		creditType,
		dealType,
		downPayment,
		loanTerm,
		monthlyBudget,
		tradeIn
	} = walletData;

	// if you update this, make sure to also update the unit tests: injectCAIWalletConfig.test.js
	const format = [
		'My Wallet/Offer Details:',
		'  Deal Type: '.concat(dealType || 'Finance', ',')
	];

	if (budget) {
		format.push('  Sale Price: '.concat(parseCurrency(budget), ','));
	}

	if (downPayment !== null) {
		format.push('  Down Payment: '.concat(parseCurrency(downPayment), ','));
	}

	if (creditType) {
		format.push('  Credit Range: '.concat(creditRange[creditType], ','));
	}

	if (loanTerm) {
		format.push('  Terms: '.concat(loanTerm, ' months,'));
	}

	if (monthlyBudget) {
		format.push('  Payment: '.concat(parseCurrency(monthlyBudget), ','));
	}

	if (tradeIn?.value) {
		format.push('  Trade-In Value: '.concat(parseCurrency(tradeIn.value)));
	}

	return format.join('\n');
};

export default formatCAIWallet;
